import { LegalDocumentScreen } from '@/src/features/legal/LegalDocumentScreen';
import { privacyPolicy } from '@/src/features/legal/legal-documents';

export default function PrivacyScreen() {
  return <LegalDocumentScreen document={privacyPolicy} />;
}
